import gql from 'graphql-tag'

export const userDelete = gql`
  mutation userDelete($userId: ID!) {
    userDelete(input: { userId: $userId }) {
      success
    }
  }
`
